import { useContext } from 'react';
import { TenantContext, type TenantContextValue } from './context';

/** The space served by this host: configuration, branding and display name. */
export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  if (!context) throw new Error('useTenant must be used inside <TenantProvider>.');
  return context;
}
